import { useEffect } from 'react';
import { useAuthLink } from 'lib/comlink/AuthLink';
import { COLOR_MODE_ATTRIBUTE, parseColorMode } from 'lib/colorMode';

const applyColorMode = (value: unknown) => {
    document.documentElement.setAttribute(COLOR_MODE_ATTRIBUTE, parseColorMode(value));
};

export const useColorModeSupport = () => {
    const authLink = useAuthLink();

    useEffect(() => {
        applyColorMode(document.documentElement.getAttribute(COLOR_MODE_ATTRIBUTE));
        authLink?.addCallback('colorModeChange', applyColorMode);
        return () => authLink?.removeCallback('colorModeChange');
    }, [authLink]);
};
